import React, { useEffect, useState } from 'react';
import { FaBasketballBall, FaBuffer } from 'react-icons/fa';
import { MdCalendarMonth, MdOutlineCalendarMonth } from "react-icons/md";
import { IoToday } from "react-icons/io5";
import { toast } from 'react-toastify';
import { fetchAllDashboardDataAPI } from '../../utils/api';
import { FaArrowRightArrowLeft } from "react-icons/fa6";
import { numberFormat } from '../numberFormat';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import withAuth from '../../utils/withAuth';

const DashboardSection = () => {
    const [todayorder, setTodayOrder] = useState(null);
    const [yesterdayorder, setYesterdayOrder] = useState(null);
    const [sameyesterdayorder, setSameLastMonthYesterdayOrder] = useState(null);
    const [thismonth, setThisMonthOrder] = useState(null);
    const [lastmonth, setLastMonthOrder] = useState(null);
    const [totalorder, setTotalOrder] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getDashboardAllOrderTypeAgentOrder();
    }, []);

    const getDashboardAllOrderTypeAgentOrder = async () => {
        try {
            const res = await fetchAllDashboardDataAPI('super-admin-get-dashboard-overview-order-type-data');
            if (res.data.status === 1) {
                setTodayOrder(res.data.todayorder);
                setYesterdayOrder(res.data.yesterdayorder);
                setSameLastMonthYesterdayOrder(res.data.same_yesterday_last_month);
                setThisMonthOrder(res.data.thismonth);
                setLastMonthOrder(res.data.lastmonth);
                setTotalOrder(res.data.totalorder);
            } else {
                toast.warning("Check your connection");
            }
        } catch (err) {
            toast.error("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    const renderCard = (title, data, icon, bgColor) => (
        <div className="card radius-10 overflow-hidden w-100" style={{ background: bgColor }}>
            <div className="icons">
                {icon}
            </div>
            <div className="ordertype">
                <span>{title}</span>
            </div>
            <div className="ordervalue">
                <h2>{loading ? <Skeleton width={80} height={30} /> : numberFormat(data?.total_amount)}</h2>
                <small>
                    <FaArrowRightArrowLeft /> {loading ? <Skeleton width={30} /> : data?.total_num}
                </small>
            </div>
        </div>
    );

    return (
        <div className="dashboardsection">
            {renderCard('Today Orders', todayorder, <IoToday />, "#4e9191")}
            {renderCard('Yesterday Orders', yesterdayorder, <FaBuffer />, "#0e7c52")}
            {renderCard('Same Yesterday – Last Month', sameyesterdayorder, <FaBuffer />, "#627b97")}
            {renderCard('This Months Orders', thismonth, <MdCalendarMonth />, "#00CED1")}
            {renderCard('Last Months Orders', lastmonth, <MdOutlineCalendarMonth />, "#c779db")}
            {renderCard('Total Order', totalorder, <FaBasketballBall />, "#597e0d")}
        </div>
    );
};

export default withAuth(DashboardSection);
